import { useEffect, useState } from 'react';

/** Tailwind default min-width thresholds (px). "Below" ⇒ viewport width < value. */
const TAILWIND_MIN_WIDTH_PX = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536
};

/**
 * @param {'sm'|'md'|'lg'|'xl'|'2xl'} breakpoint
 * @returns {boolean} true when viewport is below that Tailwind breakpoint
 */
export default function useBelowBreakpoint(breakpoint) {
  const minPx = TAILWIND_MIN_WIDTH_PX[breakpoint];
  if (minPx === undefined) {
    throw new Error(`useBelowBreakpoint: unknown breakpoint "${breakpoint}"`);
  }

  const [isBelow, setIsBelow] = useState(undefined);

  useEffect(() => {
    const mql = globalThis.matchMedia(`(max-width: ${minPx - 1}px)`);
    const onChange = () => setIsBelow(globalThis.innerWidth < minPx);
    mql.addEventListener('change', onChange);
    setIsBelow(globalThis.innerWidth < minPx);
    return () => mql.removeEventListener('change', onChange);
  }, [minPx]);

  return !!isBelow;
}
